"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default() {
  var checkPlatform = function checkPlatform() {
    var jsBridge = !!window.WebViewJavascriptBridge;

    if (jsBridge) {
      return 'android';
    } else {
      return 'pc';
    }
  };

  var timeoutReject = function timeoutReject(reject) {
    return setTimeout(function () {
      reject(new Error('调用 electron ipcRender 超时!'));
    }, 5000);
  };

  var loadFluidsynthjsSoundFont = function loadFluidsynthjsSoundFont() {
    var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (resolve, reject) {
      var _a, _b, _c, _d;

      if (window.require && (window === null || window === void 0 ? void 0 : window.h5Version) >= '1.2.0' || force) {
        console.log("\u3010\u7EC4\u4EF6\u5E93\u3011H5 \u5F53\u524D\u5728electron\u73AF\u5883");

        var ipcRenderer = window.require('electron').ipcRenderer;

        console.log("\u3010\u7EC4\u4EF6\u5E93\u3011\u901A\u77E5electron\u83B7\u53D6FluidsynthMidi\u6587\u4EF6");
        ipcRenderer.sendToHost('getFluidsynthMidi3');
        var to = timeoutReject(reject);
        ipcRenderer.on('FluidsynthMidi3Data', function (event, args) {
          console.log('ipcRenderer监听到FluidsynthMidi3Data', event, args);
          resolve(args);
          return;
        });
        clearTimeout(to);
      } else if ((window === null || window === void 0 ? void 0 : window.Electron) && ((_b = (_a = window === null || window === void 0 ? void 0 : window.Electron) === null || _a === void 0 ? void 0 : _a.Utils) === null || _b === void 0 ? void 0 : _b.getFluidsynthMidiData)) {
        console.log('【组件库】读取本地FluidsynthMidi文件中,当前在多标签环境 getFluidsynthMidiData');
        var data = null;
        window.Electron.Utils.getFluidsynthMidiData(function (chunk, len, totalLen) {
          if (!data) {
            data = new Uint8Array(totalLen);
          }

          data.set(chunk, len);

          if (chunk.length + len >= totalLen) {
            resolve(data);
            return;
          }
        }).catch(function (err) {
          console.error('window.ELectron.Utils.getFluidsynthMidiData 读取midi失败:', err === null || err === void 0 ? void 0 : err.message);
          resolve(null);
          return;
        });
      } else if ((window === null || window === void 0 ? void 0 : window.Electron) && ((_d = (_c = window === null || window === void 0 ? void 0 : window.Electron) === null || _c === void 0 ? void 0 : _c.Utils) === null || _d === void 0 ? void 0 : _d.getFluidsynthMidi)) {
        console.log('【组件库】读取本地FluidsynthMidi文件中,当前在多标签环境 getFluidsynthMidi');
        window.Electron.Utils.getFluidsynthMidi().then(function (res) {
          return resolve(res);
        }).catch(function (err) {
          console.error('window.ELectron.Utils.getFluidsynthMidi 读取midi失败:', err === null || err === void 0 ? void 0 : err.message);
          resolve(null);
        });
      } else {
        console.log("\u3010\u7EC4\u4EF6\u5E93\u3011\u8BFB\u53D6\u672C\u5730FluidsynthMidi\u6587\u4EF6\u5931\u8D25");
      }
    });
  };

  return {
    checkPlatform: checkPlatform,
    loadFluidsynthjsSoundFont: loadFluidsynthjsSoundFont
  };
};

exports.default = _default;